export const BACKEND_URL = "https://ksm-backend.volgmed.ru/";
export const IMAGE_URL = "https://ksm-backend.volgmed.ru/images/";
